export const MuiSelect = () => ({
  select: {
    '&:focus': {
      backgroundColor: 'transparent'
    }
  }
});
